import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Season } from '@app/features/common/season/model/season.model';
import { SeasonService } from '@app/features/common/season/service/season.service';
import { SeasonValidatorService } from '@app/features/common/season/validator/season-validator.service';

@Component({
  selector: 'app-dropdown-season-select',
  templateUrl: './dropdown-season-select.component.html',
  styleUrls: ['./dropdown-season-select.component.scss']
})
export class DropdownSeasonSelectComponent implements OnInit {

  @ViewChild('seasonCode') seasonCode: ElementRef;
  @ViewChild('dropdown') dropDown: ElementRef;

  @Output() changeMethod = new EventEmitter<Season>();

  @Input() season: Season;
  @Input() isDefault: boolean;

  form: FormGroup;

  constructor(
    private seasonValidator: SeasonValidatorService,
    private seasonService: SeasonService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      seasonCode: new FormControl(this.seasonCode,
        {
          validators: [
            Validators.required,
            this.seasonValidator.exists(false, false, true, null, null, (season: Season) => {
              this.setSeason(season);
            })
          ]
        })
    });
  }

  setSeason(season: Season): void {
    season.startDatetime = new Date(season.startDatetime);
    season.endDatetime = new Date(season.endDatetime);
    if (!this.season || season.code !== this.season.code) {
      if (this.isDefault) {
        this.seasonService.setDefaultSeason(season);
      } else {
        this.changeMethod.next(season);
      }
      this.renderer.removeClass(this.dropDown.nativeElement, 'show');
    }
  }

  setFocus(): void {
    setTimeout(() => {
      if (this.season) {
        if (this.seasonCode !== this.form.get('seasonCode').value) {
          this.form.get('seasonCode').setValue(this.season.code);
        }
      }
      if (this.seasonCode) {
        this.seasonCode.nativeElement.focus();
      }
    }, 100);
  }

  changeSeason(season: string): void{
    if (!season && this.season) {
      this.seasonService.removeDefaultSeason();
    }
  }
}
